<template>
  <div class="video-wrapper">
    <video
      class="background-video"
      autoplay
      loop
      muted
      playsinline
      disablePictureInPicture
      controlslist="nodownload nofullscreen noremoteplayback"
    >
      <source src="/galaxy.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  name: "GetawayView",
};
</script>

<style scoped>
.video-wrapper {
  position: relative;
  width: 100%;
  /* Height is auto so it scales with width; if you need full height, you can do min-height: 100vh, but that can force cropping. */
  height: auto;
  overflow: hidden;
}

.background-video {
  width: 100%;
  height: auto;
  object-fit: contain; /* Preserves entire video, adds black bars if needed */
  display: block;
}

/* Centered Overlay Content */
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white; /* Ensures text is visible */
  font-size: 2rem;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7);
}
</style>
